module.exports = __webpack_public_path__ + "img/happiness-logo.d53cf515.png";